import React, {FC} from 'react'
//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { LKDate } from 'loankeeper-common/helpers/Date'
import { constants as DCConstants } from '../../DetailsContainer'

import { OverduesProps } from '../types.LoanDetails'

const LKGridConfig = {
  columnConfigs: {
    sDate: { valueFormatter: ({ value }) => LKDate.from(value).toString() },
  },

  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableColumnsHide: false,
  syncGridState: true,
  enableRowSelection: true,
  enableSorting: false,
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'dbgrd_overdues',
  },
}

const Overdues: FC<OverduesProps> = ({ ID, data: { overdues } }) => (
  <div className="u-flex u-fluid u-relative">
    <LKGrid
      instanceName={`${DCConstants.DetailsGridPrefixes.loan}-${ID}-Overdues`}
      rowData={overdues}
      {...LKGridConfig}
    />
  </div>
)

export default Overdues
